module.exports = __webpack_public_path__ + "public/img/tower1.6c2f7b6b.gif";